<template>
	<div class="lc">
		<!-- logo -->
		<div data-tour="logo">
			<div class="lc-section">Logo</div>
			<div class="lc-logos">
				<div v-for="(item, index) in loghi" :key="index" class="lc-logo">
					<img :src="item.sizes && item.sizes[0] && item.sizes[0].value" alt="" />
					<v-btn icon x-small class="lc-logo-del" title="Togli questo logo" @click="$emit('elimina', index)"><v-icon x-small>mdi-close</v-icon></v-btn>
				</div>
				<div class="lc-drop">
					<vue-dropzone
						id="dropzonelogo"
						ref="dropzoneLogo"
						:options="dropzoneOptions"
						:use-custom-slot="true"
						@vdropzone-complete="f => $emit('caricato', f)"
						@vdropzone-sending="(f, x, d) => $emit('invio', f, x, d)"
					>
						<div class="lc-drop-text">
							<v-icon color="primary">mdi-cloud-upload-outline</v-icon>
							<div><strong>Trascina qui il logo</strong> o clicca per sceglierlo</div>
							<div class="lc-muted">SVG (consigliato), JPG, GIF o PNG</div>
						</div>
					</vue-dropzone>
				</div>
			</div>
		</div>

		<!-- colori -->
		<div class="mt-5" data-tour="colors">
			<div class="lc-section">Colori del tema</div>
			<div class="lc-colors">
				<v-menu v-for="c in colori" :key="c.key" :close-on-content-click="false" offset-y max-width="320">
					<template v-slot:activator="{ on, attrs }">
						<button type="button" class="lc-color" v-bind="attrs" v-on="on" :title="'Cambia ' + c.label.toLowerCase()">
							<span class="lc-swatch" :style="{ background: hex(form.layout[c.key]) || '#ffffff' }"></span>
							<span class="lc-color-text">
								<span class="lc-color-name">{{ c.label }}</span>
								<span class="lc-color-hex">{{ hex(form.layout[c.key]) || 'non impostato' }}</span>
								<span class="lc-muted">{{ c.uso }}</span>
							</span>
							<v-icon small class="lc-edit">mdi-pencil-outline</v-icon>
						</button>
					</template>
					<v-card>
						<v-color-picker v-model="form.layout[c.key]" dot-size="24" mode="hexa" />
					</v-card>
				</v-menu>
			</div>
		</div>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

// logo del sito e i quattro colori del tema (i colori restano nel formato del v-color-picker, come prima)
export default {
	name: 'LogoColori',
	components: { vueDropzone: vue2Dropzone },
	props: {
		form: { type: Object, required: true },
		dropzoneOptions: { type: Object, required: true },
	},
	data() {
		return {
			colori: [
				{ key: 'color', label: 'Primario', uso: 'pulsanti, link, elementi in evidenza' },
				{ key: 'color_secondary', label: 'Secondario', uso: 'dettagli e sfondi di accompagnamento' },
				{ key: 'color_third', label: 'Terzo', uso: 'testi e parti neutre' },
				{ key: 'color_accent', label: 'Accento', uso: 'badge, offerte, avvisi' },
			],
		};
	},
	computed: {
		loghi() {
			return (this.form.layout && this.form.layout.logo) || [];
		},
	},
	methods: {
		hex(v) {
			if (!v) return '';
			if (typeof v === 'string') return v.slice(0, 7).toUpperCase();
			return (v.hex || '').toUpperCase();
		},
	},
};
</script>

<style scoped>
.lc-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 8px;
}
.lc-muted {
	color: #5f6b7a;
	font-size: 12px;
}
.lc-logos {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	align-items: stretch;
}
.lc-logo {
	position: relative;
	width: 140px;
	height: 110px;
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	background: repeating-conic-gradient(#f3f6fa 0% 25%, #fff 0% 50%) 50% / 16px 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
}
.lc-logo img {
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
}
.lc-logo-del {
	position: absolute;
	top: 4px;
	right: 4px;
	background: #fff;
}
.lc-drop {
	flex: 1 1 260px;
	min-width: 220px;
}
.lc-drop ::v-deep .vue-dropzone {
	min-height: 110px;
	padding: 10px;
	border: 1px dashed #9fb6d3;
	border-radius: 10px;
	background: #f7faff;
}
.lc-drop ::v-deep .dz-message {
	margin: 0;
}
.lc-drop-text {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2px;
	font-size: 13px;
	color: #1f2d3d;
}
.lc-colors {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	gap: 10px;
}
.lc-color {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 12px;
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	background: #fff;
	text-align: left;
	cursor: pointer;
}
.lc-color:hover {
	border-color: #9fb6d3;
}
.lc-swatch {
	flex: 0 0 40px;
	width: 40px;
	height: 40px;
	border-radius: 8px;
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
}
.lc-color-text {
	display: flex;
	flex-direction: column;
	min-width: 0;
	flex: 1 1 auto;
}
.lc-color-name {
	font-weight: 600;
	font-size: 13px;
	color: #1f2d3d;
}
.lc-color-hex {
	font-family: monospace;
	font-size: 12px;
	color: #1f2d3d;
}
.lc-edit {
	color: #8a96a3 !important;
}
</style>
